<template>
  <common-card>
    <v-toolbar color="primary" dense dark flat>
      <v-toolbar-title>
        <span class="font-montserrat font-weight-bold">Reporte de Pagos</span>
      </v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <v-row>
        <v-col md="3">
          <v-select
            label="Seleccionar Alianza"
            :items="alianzas"
            item-text="nombre"
            item-value="id"
            v-model="alianza"
            outlined
            class="mt-5"
          />

          <v-radio-group v-model="modo" row>
            <v-radio label="Rango de fechas" value="rango" />
            <v-radio label="General" value="general" />
          </v-radio-group>

          <v-date-picker
            v-if="modo === 'rango'"
            v-model="dates"
            range
            :allowed-dates="validarFecha"
            locale="es"
          />

          <v-btn
            block
            color="primary"
            dark
            :loading="loading"
            :disabled="!puedeEjecutar"
            class="mt-4"
            @click="consultar"
          >
            Ejecutar Reporte
          </v-btn>

          <v-btn
            block
            class="mt-3"
            color="success"
            :loading="loading"
            :disabled="polizas.length === 0"
            @click="descargarCSV"
          >
            Descargar
          </v-btn>
        </v-col>

        <v-col md="9">
          <v-data-table
            :headers="columns"
            :items="polizas"
            :page.sync="page"
            :items-per-page="size"
            :server-items-length="totalItems"
            :loading="loading"
            @update:page="onPageChange"
            @update:items-per-page="onItemsPerPageChange"
            class="elevation-1"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </common-card>
</template>

<script>
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import moment from "moment";
import {
  getReportePagosAlianzas,
  getReportePagosCSV,
} from "@/services/reportes/reportes.service.js";
import { getAlianzas } from "@/services/alianzas/alianzas.service";

export default {
  components: {
    CommonCard,
  },
  data() {
    return {
      alianza: null,
      alianzas: [],
      modo: "rango",
      dates: [],
      polizas: [],
      page: 1,
      size: 10,
      totalItems: 0,
      loading: false,
      hasExecutedQuery: false,
      statusMap: {
        0: "Nueva",
        1: "Activa",
        2: "Activa",
        3: "Activa",
        4: "Inactiva",
        5: "Inactiva",
        6: "Cancelada",
        7: "Duplicada",
        8: "Reactivacion",
      },
      columns: [
        { text: "Id", value: "id" },
        { text: "No Cuota", value: "orden" },
        { text: "Certificado", value: "certificado" },
        { text: "Cliente", value: "cliente" },
        { text: "Factura", value: "factura" },
        { text: "Monto", value: "monto" },
        { text: "Fecha Pago ", value: "fechaPago" },
      ],
    };
  },
  computed: {
    puedeEjecutar() {
      return (
        this.alianza &&
        (this.modo === "general" ||
          (this.modo === "rango" &&
            this.dates.length === 2 &&
            this.validarFecha(this.dates[0])))
      );
    },
    hasRange() {
      return this.dates.length === 2;
    },
  },
  watch: {
    modo() {
      this.dates = [];
      this.polizas = [];
    },
  },
  methods: {
    validarFecha(fecha) {
      const fechaLimite = moment()
        .subtract(2, "months")
        .startOf("day");
      return moment(fecha).isSameOrAfter(fechaLimite);
    },

    async obtenerAlianzas() {
      this.alianzas = await getAlianzas();
    },

    onPageChange(newPage) {
      this.page = newPage;
      if (this.hasExecutedQuery) {
        this.fetchData();
      }
    },

    onItemsPerPageChange(newItemsPerPage) {
      this.size = newItemsPerPage;
      this.page = 1;
      if (this.hasExecutedQuery) {
        this.fetchData();
      }
    },

    async fetchData() {
      if (!this.puedeEjecutar) return;

      try {
        let fechas = [];
        if (this.modo === "rango" && this.dates.length === 2) {
          fechas = [
            moment.utc(this.dates[0]).format("YYYY-MM-DD"),
            moment.utc(this.dates[1]).format("YYYY-MM-DD"),
          ];
        }

        const filters = {
          fechas,
          alianza: String(this.alianza),
          limit: this.size,
          page: this.page - 1,
          order: "desc",
        };

        this.loading = true;

        const data = await getReportePagosAlianzas(filters);

        this.polizas = data.data;
        this.totalItems = data.count;
      } catch (err) {
        console.error("Error al consultar reporte:", err);
      } finally {
        this.loading = false;
      }
    },

    async consultar() {
      this.page = 1;
      this.reportDownload = [];
      this.hasExecutedQuery = true;
      await this.fetchData();
    },

    descargarCSV() {
      try {
        const body = {
          alianzaId: this.alianza,
        };

        if (this.modo === "rango" && this.dates.length === 2) {
          const inicio = moment.utc(this.dates[0]).format("YYYY-MM-DD");
          const fin = moment
            .utc(this.dates[1])
            .add(24, "hours")
            .subtract(1, "seconds")
            .format("YYYY-MM-DD");

          body.fechas = [inicio, fin];
        }
        this.loading = true;

        getReportePagosCSV(body);
      } catch (err) {
        console.error("Error al consultar reporte:", err);
      } finally {
        this.loading = false;
      }
    },
  },

  mounted() {
    this.obtenerAlianzas();
  },
};
</script>
